import { IUpcomingPayment, } from "../../../api";
import { Flex, Stack, Text, } from "@chakra-ui/react";
import { PageLoader, } from "../../shared/PageLoader";
import { PaymentCard, } from "../PaymentsPage/Payments";

interface IPaymentsListView {
  isLoading: boolean;
  isSuccess: boolean;
  data: IUpcomingPayment[];
}

export function PaymentsListView({ isLoading, isSuccess, data, }: IPaymentsListView,) {
  return (
    <Stack spacing={2}>
      {isLoading && (
        <PageLoader />
      )}

      {isSuccess && data.length > 0 && data
        .map(payment => (
          <PaymentCard
            key={payment.id}
            id={payment.id}
            name={payment.name}
            date={payment.date}
            amount={payment.amount}
            type={payment.type}
            isOverdue={payment.isOverdue}
          />
        ),)}

      {isSuccess && data.length === 0 && (
        <Flex
          justifyContent="center"
          alignItems="center"
          minH="60vh"
        >
          <Text>Все оплачено, ждем новых покупок!</Text>
        </Flex>
      )}
    </Stack>
  );
}
